import styled from "styled-components";

export const ShumokuManagementPageStyled = styled.div`
  height: 100vh;
  height: 100dvh;
`;
